module.exports = __webpack_public_path__ + "img/icon-email.418f73d8.png";